import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { setOrderAction } from '../../app/actions/SetOrderAction';
import { enterSpace } from '../../app/actions/spaces/EnterSpaceAction';
import { requestSpaceContents } from '../../app/actions/spaces/RequestSpaceContentsActions';
import { getOrderClausesFromQueryParam } from '../../app/spaces/Explorer/ExplorerUrlBindings';
import { SpaceInfo } from '../../app/state/SpaceInfo';
import { UrlParamKeys } from '../../app/UrlParamKeys';
import { Messages } from '../../codegen/Localize';
import { getQueryStringServiceFromAngular } from '../../common/react/QueryString';
import { getDefaultOrderForFlowSubSpace } from '../../ts/models/sort/SortOptionDefinitions';
import { EnterFlowSubspaceReduxAction } from '../actions/EnterFlowSubspaceAction';

export function* handleEnterFlowSubspace(action: EnterFlowSubspaceReduxAction): SagaIterator {
  try {
    const spaceInfo: SpaceInfo = {
      item: action.flowDetailInfo,
      spaceType: 'flow',
      subspaceName: action.subspaceName,
    };
    yield put(enterSpace(spaceInfo));
    const orderFromQuery = getOrderClausesFromQueryParam(
      getQueryStringServiceFromAngular()()[UrlParamKeys.Order],
      getDefaultOrderForFlowSubSpace(spaceInfo)
    );
    yield put(setOrderAction(orderFromQuery));
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}
